<script>
</script>

<div class="grid lg:grid-cols-2 gap-5 px-2">
    <div class="block flex-1 space-y-4 ">
        <slot/>
    </div>
    {#if $$slots["right"]}
       <div class="flex-1 block lg:border-l border-neutral-100 space-y-4 lg:pl-6">
           <slot name="right"/>
       </div>

    {/if}
</div>